import { Fragment } from 'react';
import { DotIcon } from '../../icons/DotIcon';
import { Bar, DotSeparator, Pill } from './JourneyPickerCondensed.styles';
import type { JourneyPickerSection } from './JourneyPicker.types';

export interface JourneyPickerCondensedProps {
  showCategory: boolean;
  currentCategoryLabel: string;
  datesLabel: string;
  displayGuests: boolean;
  guestsLabel: string;
  onEditSection?: (section: JourneyPickerSection) => void;
}

export function JourneyPickerCondensed({
  showCategory,
  currentCategoryLabel,
  datesLabel,
  displayGuests,
  guestsLabel,
  onEditSection,
}: JourneyPickerCondensedProps) {
  const sections: Array<{ id: JourneyPickerSection; label: string }> = [];
  if (showCategory) sections.push({ id: 'module', label: currentCategoryLabel });
  sections.push({ id: 'dates', label: datesLabel });
  if (displayGuests) sections.push({ id: 'guests', label: guestsLabel });

  return (
    <Bar>
      {sections.map((section, i) => (
        <Fragment key={section.id}>
          {i > 0 && (
            <DotSeparator aria-hidden>
              <DotIcon />
            </DotSeparator>
          )}
          <Pill
            type="button"
            onClick={() => onEditSection?.(section.id)}
            disabled={!onEditSection}
          >
            {section.label}
          </Pill>
        </Fragment>
      ))}
    </Bar>
  );
}
